import { FiChevronDown } from 'react-icons/fi'

import { useTrackerMapContext } from '../TrackerMapContext'
import { type StatusFilterValue } from '../types'

const options: { value: StatusFilterValue; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'online', label: 'Online' },
  { value: 'offline', label: 'Offline' },
]

// Client-side filter over live tracker rows ('stale' status = offline). Rows
// without a tracker or frozen at shipment end only show under 'All'.
export const StatusFilter = () => {
  const { filters, setFilters } = useTrackerMapContext()

  const handleChange = (value: StatusFilterValue) => setFilters({ ...filters, status: value })
  const currentLabel = options.find((o) => o.value === filters.status)?.label ?? 'All'

  return (
    <div className="dropdown" data-filter-dropdown>
      <div
        tabIndex={0}
        role="button"
        className="btn btn-sm btn-outline min-w-[140px] flex items-center justify-between font-normal"
      >
        <span>Status: {currentLabel}</span>
        <FiChevronDown className="w-4 h-4 text-base-content/60" />
      </div>
      <ul
        tabIndex={0}
        className="dropdown-content menu bg-base-100 rounded-lg shadow-lg border border-base-300 z-20 w-full p-1 mt-1"
      >
        {options.map((opt) => (
          <li key={opt.value}>
            <button
              onClick={() => handleChange(opt.value)}
              className={`text-xs ${filters.status === opt.value ? 'active' : ''}`}
            >
              Status: {opt.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
